import Styled from '../../lib/styles/styled-deprecated';
export default Styled;
